module.exports = __webpack_public_path__ + "img/ship.cd693725.png";